import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box, ButtonBase,
  Hidden,
  IconButton,
  Toolbar, Typography,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { AccountCircle } from "@material-ui/icons";
import Logo from '../Logo';

const DashboardNavbar = ({
  onDrawerToggle,
  name,
  roleName,
  onProfileDialogOpen,
}) => (
  <AppBar
    elevation={0}
  >
    <Toolbar>
      <RouterLink to="/">
        <Logo />
      </RouterLink>
      <Box sx={{ flexGrow: 1 }} />
      <Hidden mdUp>
        <IconButton color="inherit" onClick={onDrawerToggle} size="large">
          <MenuIcon />
        </IconButton>
      </Hidden>
      <Box display="flex" justifyContent="center" alignItems="center" width="min-content" height="100%">
        <ButtonBase onClick={() => onProfileDialogOpen()}>
          <Box mr={2} height="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="start">
            <Typography fontSize={16} style={{ whiteSpace: 'nowrap' }}>
              {name}
            </Typography>
            <Typography fontSize={12} style={{ whiteSpace: 'nowrap' }}>
              {roleName}
            </Typography>
          </Box>
          <AccountCircle style={{ fontSize: '42px' }} />
        </ButtonBase>
      </Box>
    </Toolbar>
  </AppBar>
);

DashboardNavbar.propTypes = {
  onDrawerToggle: PropTypes.func.isRequired,
};

export default DashboardNavbar;
